// DIRECT WebSocket using PUSHER PROTOCOL (NO laravel-echo, NO pusher-js)

let socket = null;
let reconnectTimer = null;
let isManualClose = false;
const WS_URL = process.env.REACT_APP_LIVECHAT_SOCKET_URL;

const listeners = new Map();
let socketId = null;
let messageQueue = [];

function safeSend(data) {
  if (!socket || socket.readyState !== WebSocket.OPEN) {
    messageQueue.push(data);
    return;
  }
  socket.send(JSON.stringify(data));
}

function flushQueue() {
  while (messageQueue.length) {
    socket.send(JSON.stringify(messageQueue.shift()));
  }
}

function connect() {
  if (socket) return;

  console.log("🔌 Connecting LiveChat WebSocket...");
  socket = new WebSocket(WS_URL);

  socket.onopen = () => {
    console.log("✅ LiveChat WebSocket connected");
  };

  socket.onmessage = (e) => {
    const msg = JSON.parse(e.data);
    console.log("📩 LiveChat WS message:", msg);

    // 1️⃣ Connection established
    if (msg.event === "pusher:connection_established") {
      socketId = JSON.parse(msg.data).socket_id;
      flushQueue();

      // Subscribe existing channels
      listeners.forEach((_, channel) => {
        subscribe(channel);
      });
      return;
    }

    // 2️⃣ Generic event forwarding
    if (msg.event && msg.channel) {
      listeners.get(msg.channel)?.forEach((cb) =>
        cb(msg.event, JSON.parse(msg.data))
      );
    }
  };

  socket.onclose = () => {
    socket = null;
    socketId = null;

    if (!isManualClose) {
      reconnectTimer = setTimeout(connect, 3000);
    }
  };
}

function subscribe(channel) {
  safeSend({
    event: "pusher:subscribe",
    data: {
      channel,
    },
  });

  console.log("📡 Subscribed:", channel);
}

const echo = {
  channel(channelName) {
    if (!listeners.has(channelName)) {
      listeners.set(channelName, []);
    }

    connect();
    subscribe(channelName);

    return {
      listen(event, callback) {
        // Wrap callback to only fire for the right event
        const wrapped = (msgEvent, data) => {
          if (msgEvent === event) callback(data);
        };
        listeners.get(channelName).push(wrapped);
      },
    };
  },

  leave(channelName) {
    safeSend({
      event: "pusher:unsubscribe",
      data: { channel: channelName },
    });
    listeners.delete(channelName);
  },

  disconnect() {
    isManualClose = true;
    socket?.close();
    socket = null;
    messageQueue = [];
  },
};

export default echo;

// compatibility exports
export const createEchoWithAuth = () => echo;
export const updateEchoAuth = () => {};
export const disconnectEcho = () => echo.disconnect();